"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _hooks = require("../../../hooks");
var _Site = require("../Site.config");
const useStyles = (expandOnHover, isSelected, isOpen, isMoreMenuItem, withTopSeparator) => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const ccSideBarStyle = (0, _react.useMemo)(() => {
    const deviceProps = () => {
      if (isMobileView && !isMoreMenuItem) {
        return {
          top: 'auto',
          width: '100vw',
          height: pxToRem(_Site.sidebarHeight),
          zIndex: 5,
          boxShadow: `0 0 ${pxToRem(7)} ${themeColors?.primary.shadow}`
        };
      }
      return {
        top: 0,
        transition: 'width 0.5s ease',
        width: pxToRem(expandOnHover ? _Site.sidebarShrinkWidth : _Site.sidebarWidth),
        zIndex: 1,
        '&:hover': {
          width: pxToRem(_Site.sidebarWidth)
        }
      };
    };
    const menuDeviceProps = () => {
      if (isMobileView && !isMoreMenuItem) {
        return {
          width: '100%',
          height: '100%',
          margin: 0,
          position: 'absolute',
          display: 'flex',
          flexDirection: 'row',
          background: themeColors?.general.light
        };
      }
      return {
        margin: pxToRem(10)
      };
    };
    const menuItemDeviceProps = () => {
      if (isMobileView && !isMoreMenuItem) {
        return {
          flex: '1 1',
          fontSize: pxToRem(14)
        };
      }
      return {
        marginTop: pxToRem(4)
      };
    };
    const menuItemAnchorContentDeviceProps = () => {
      if (isMobileView && !isMoreMenuItem) {
        return {
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center'
        };
      }
      return {
        flexDirection: 'row',
        justifyContent: 'flex-start'
      };
    };
    const ccSideBar = (0, _css.css)({
      fontFamily,
      position: 'absolute',
      bottom: 0,
      ...deviceProps()
    });
    const ccSideBarMenu = (0, _css.css)({
      listStyle: 'none',
      padding: 0,
      fontWeight: 'bold',
      ...menuDeviceProps()
    });
    const ccSideBarMenuItem = (0, _css.css)({
      ...menuItemDeviceProps(),
      borderTop: withTopSeparator ? `1px solid #DAD9FC` : '',
      paddingTop: withTopSeparator ? pxToRem(4) : '0'
    });
    const ccSideBarMenuItemAnchor = () => {
      return {
        width: '100%',
        boxSizing: 'border-box',
        paddingInline: 0,
        height: isMobileView ? isMoreMenuItem ? pxToRem(30) : '100%' : pxToRem(36),
        color: isSelected ? themeColors?.primary.main : 'inherit',
        background: isSelected ? themeColors?.basic.main : ''
      };
    };
    const ccSideBarMenuItemAnchorContent = (0, _css.css)({
      display: 'inline-flex',
      alignItems: 'center',
      width: '100%',
      overflow: 'hidden',
      height: '100%',
      ...menuItemAnchorContentDeviceProps()
    });
    const menuItemLabelDeviceProps = () => {
      if (isMobileView) {
        if (isMoreMenuItem) {
          return {
            // padding: `0 ${pxToRem(4)}`,
            marginRight: pxToRem(10),
            fontSize: pxToRem(16)
          };
        }
        return {
          padding: `${pxToRem(4)} 0`,
          fontSize: pxToRem(12),
          lineHeight: 1
        };
      }
      return {
        // padding: pxToRem(4),
        marginInlineStart: pxToRem(10),
        fontSize: 'inherit'
      };
    };
    const ccSideBarMenuItemIcon = (0, _css.css)({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    });
    const BarMenuItemLabelExpandOnHover = () => {
      if (expandOnHover) {
        return {
          transition: 'width 0.5s ease',
          overflow: 'hidden',
          textWrap: 'nowrap',
          width: '100%'
        };
      }
      return {};
    };
    const ccSideBarMenuItemLabel = (0, _css.css)({
      // lineHeight: 1,
      display: 'flex',
      alignItems: 'center',
      ...BarMenuItemLabelExpandOnHover(),
      ...menuItemLabelDeviceProps()
    });
    const ccSideBarMenuItemNewItem = (0, _css.css)({
      background: 'linear-gradient(180deg, #5750FA 0%, #0A00FF 100%)',
      borderRadius: pxToRem(20),
      border: 'none',
      padding: `${pxToRem(2.5)} ${pxToRem(9)} ${pxToRem(2)}`,
      marginInlineStart: 'auto',
      marginLeft: pxToRem(12),
      lineHeight: pxToRem(18),
      textAlign: 'center',
      fontSize: isMobileView ? pxToRem(10) : pxToRem(12),
      color: themeColors?.general.light,
      fontWeight: 'normal',
      letterSpacing: 0.75,
      width: 'auto',
      transition: 'width 0.5s ease'
    });
    const ccSideBarMenuItemArrow = (0, _css.css)({
      display: 'flex',
      alignItems: 'center',
      marginInlineStart: 'auto',
      marginLeft: pxToRem(12),
      transform: isOpen ? 'scaleY(-1)' : 'scaleY(1)',
      transition: 'transform .2s ease-in-out'
    });
    const ccSideBarMenuItemInnerList = (0, _css.css)({
      fontWeight: 'normal',
      paddingInlineStart: pxToRem(24),
      transition: 'max-height .3s ease-in-out',
      listStyleType: 'none',
      maxHeight: isOpen ? pxToRem(480) : 0,
      overflow: 'hidden'
    });
    const ccSideBarMenuItemMoreBtn = (0, _css.css)({
      fontSize: pxToRem(12),
      fontWeight: 'bold',
      display: 'flex',
      flexDirection: 'column'
    });
    const ccSideBarMenuItemMoreMenu = (0, _css.css)({
      listStyle: 'none',
      padding: 0,
      fontWeight: 'bold'
    });
    return {
      ccSideBar,
      ccSideBarMenu,
      ccSideBarMenuItem,
      ccSideBarMenuItemIcon,
      ccSideBarMenuItemLabel,
      ccSideBarMenuItemNewItem,
      ccSideBarMenuItemArrow,
      ccSideBarMenuItemAnchor,
      ccSideBarMenuItemAnchorContent,
      ccSideBarMenuItemInnerList,
      ccSideBarMenuItemMoreBtn,
      ccSideBarMenuItemMoreMenu
    };
  }, [fontFamily, pxToRem, isOpen, isMobileView, isMoreMenuItem, themeColors?.primary.shadow, themeColors?.primary.main, themeColors?.general.light, themeColors?.basic.main, isSelected, withTopSeparator, expandOnHover]);
  return {
    'cc-SideBar': ccSideBarStyle.ccSideBar,
    'cc-SideBar__menu': ccSideBarStyle.ccSideBarMenu,
    'cc-SideBar__menu__item': ccSideBarStyle.ccSideBarMenuItem,
    'cc-SideBar__menu__item__anchor': ccSideBarStyle.ccSideBarMenuItemAnchor,
    'cc-SideBar__menu__item__anchor-content': ccSideBarStyle.ccSideBarMenuItemAnchorContent,
    'cc-SideBar__menu__item__icon': ccSideBarStyle.ccSideBarMenuItemIcon,
    'cc-SideBar__menu__item__label': ccSideBarStyle.ccSideBarMenuItemLabel,
    'cc-SideBar__menu__item__new-item': ccSideBarStyle.ccSideBarMenuItemNewItem,
    'cc-SideBar__menu__item__arrow': ccSideBarStyle.ccSideBarMenuItemArrow,
    'cc-SideBar__menu__item__inner-list': ccSideBarStyle.ccSideBarMenuItemInnerList,
    'cc-SideBar__menu__item__more-btn': ccSideBarStyle.ccSideBarMenuItemMoreBtn,
    'cc-SideBar__menu__item__more-menu': ccSideBarStyle.ccSideBarMenuItemMoreMenu
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;